import {
  createStore,
  applyMiddleware
} from 'redux';
import {
  composeWithDevTools
} from 'redux-devtools-extension';

import rootReducer, { initState } from './reducers/rootReducer';

const store = createStore(rootReducer, initState, composeWithDevTools(applyMiddleware()));

export default store;
